var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMusicPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75c-3.65 0-5.75-2.1-5.75-5.75v-5c0-3.65 2.1-5.75 5.75-5.75h10c3.65 0 5.75 2.1 5.75 5.75v5c0 3.65-2.1 5.75-5.75 5.75H7zM2.75 12v5c0 2.86 1.39 4.25 4.25 4.25h10c2.86 0 4.25-1.39 4.25-4.25v-5c0-2.86-1.39-4.25-4.25-4.25H7c-2.86 0-4.25 1.39-4.25 4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75H6zM9 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77 17.74a2.121 2.121 0 0 1 4.24 0 2.121 2.121 0 0 1-4.24 0zm1.5 0c0 .34.28.62.62.62.34 0 .62-.28.62-.62 0-.34-.28-.62-.62-.62-.34 0-.62.28-.62.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51 17.74v-5.51c0-.88.55-1.59 1.39-1.82l2.74-.75c.87-.24 1.42-.01 1.72.23.3.23.66.7.66 1.59v5.35c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5.35c0-.28-.06-.39-.08-.4-.02-.01-.14-.05-.42.03l-2.73.75c-.25.07-.29.24-.29.38v5.51c.01.4-.33.74-.74.74s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.79 16.83a2.121 2.121 0 0 1 4.24 0 2.121 2.121 0 0 1-4.24 0zm1.5 0c0 .34.28.62.62.62.34 0 .62-.28.62-.62 0-.34-.28-.62-.62-.62-.34 0-.62.28-.62.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54 14.03a.75.75 0 0 1 .53-.92l5.01-1.37a.75.75 0 1 1 .39 1.45l-5.01 1.37c-.07.01-.13.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicPlaylist);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-playlist.877efb743a143335c61994f0b7e7fcb8.svg";
export { ForwardRef as ReactComponent };